import styled from '@emotion/styled';
import { theme } from '@arnold/common';

export const Bar = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  min-width: 0;
`;
export const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: 7px;
  margin: 0;
  min-width: 0;
  font-size: 12px;
  font-weight: 500;
  input:not([type='checkbox']),
  select,
  textarea {
    font: inherit;
    font-size: 13px;
    font-weight: 400;
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    max-width: 100%;
    padding: 10px 12px;
    border: 1px solid ${theme.colors.borderSeparator.default};
    border-radius: 6px;
    background: ${theme.colors.backgroundCover.default};
    color: ${theme.colors.text.primary};
    &:focus {
      outline: 0;
      border-color: ${theme.colors.actionPrimary.default};
      box-shadow: 0 0 0 1px ${theme.colors.actionPrimary.default};
    }
  }
  textarea {
    min-height: 76px;
    resize: vertical;
  }
`;
export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  min-width: 0;
`;
export const InlineAdd = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 10px;
  align-items: end;
  min-width: 0;
`;
export const Row = styled.div`
  padding: 14px 0;
  border-bottom: 1px solid ${theme.colors.borderSeparator.default};
  min-width: 0;
`;
export const Action = styled.button<{ active?: boolean; primary?: boolean }>`
  border: 1px solid
    ${({ primary }) => (primary ? theme.colors.actionPrimary.default : theme.colors.borderSeparator.default)};
  border-radius: 6px;
  padding: 9px 12px;
  font: inherit;
  font-size: 13px;
  line-height: 18px;
  font-weight: 500;
  cursor: pointer;
  background: ${({ primary, active }) =>
    primary
      ? theme.colors.actionPrimary.default
      : active
        ? theme.colors.backgroundBasic.active
        : theme.colors.backgroundCover.default};
  color: ${({ primary }) => (primary ? theme.colors.textInverted.primary : theme.colors.text.primary)};
  text-align: center;
  flex-shrink: 0;
  &:hover:not(:disabled) {
    border-color: ${theme.colors.actionPrimary.default};
  }
  &:disabled {
    opacity: 0.45;
    cursor: default;
  }
`;
export const QuietAction = styled(Action)`
  border-color: transparent;
  padding: 6px;
  background: transparent;
  color: ${theme.colors.actionPrimary.default};
`;
export const Hint = styled.p`
  font-size: 12px;
  line-height: 1.5;
  color: ${theme.colors.text.secondary};
  margin: 0;
  overflow-wrap: anywhere;
`;
export const ErrorText = styled.p`
  font-size: 12px;
  line-height: 1.5;
  color: ${theme.colors.emotionDanger.default};
  margin: 8px 0;
  overflow-wrap: anywhere;
`;
export const FormSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px 0;
  border-bottom: 1px solid ${theme.colors.borderSeparator.default};
  min-width: 0;
  > h3 {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
  }
`;
export const Check = styled.label`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  margin: 0;
  font-size: 13px;
  line-height: 20px;
  min-width: 0;
  input {
    width: auto;
    flex: 0 0 auto;
    margin: 3px 0 0;
    accent-color: ${theme.colors.actionPrimary.default};
  }
`;
export const MappingRow = styled.label`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 100px;
  align-items: center;
  gap: 16px;
  padding: 7px 0;
  margin: 0;
  font-size: 13px;
  min-width: 0;
  border-bottom: 1px solid ${theme.colors.borderSeparator.default};
  span {
    min-width: 0;
    overflow-wrap: anywhere;
  }
  input[type='number'] {
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    padding: 8px 10px;
    border: 1px solid ${theme.colors.borderSeparator.default};
    border-radius: 6px;
    font: inherit;
  }
  input[type='checkbox'] {
    justify-self: end;
    accent-color: ${theme.colors.actionPrimary.default};
  }
`;
export const SourceBlock = styled.div`
  padding: 4px 0 16px 14px;
  border-left: 2px solid ${theme.colors.borderSeparator.default};
  display: grid;
  gap: 12px;
  min-width: 0;
`;
export const Details = styled.details`
  min-width: 0;
  > summary {
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    color: ${theme.colors.actionPrimary.default};
    list-style: none;
    display: flex;
    align-items: center;
    gap: 6px;
    &::-webkit-details-marker {
      display: none;
    }
    &::before {
      content: '▸';
      font-size: 11px;
      color: ${theme.colors.text.secondary};
    }
  }
  &[open] > summary::before {
    content: '▾';
  }
  > div {
    display: grid;
    gap: 12px;
    margin-top: 12px;
    min-width: 0;
  }
`;
